import { get } from '@/core/ajax'

// 获取菜单配置
export const getMenus = () => {
  return get('/api/menu/get.htm').then(({ menuList = [] }) => menuList || [])
}
